import { Component } from "react";

class Strategy4AddDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      brokerName: "",
      datafeedName: "",

      scrip: "NSE:NIFTY 50",
      startTime: "09:30:10",
      strikeDistance: 0,
      expiry: "2025-01-01",
      expiryType: "Weekly",
      lots: 0,
      timeframe: "minute",
      isTpnlEnabled: false,
      tradingMode: "Paper"
    }
  }

  componentDidMount() {
    let localStorageState = localStorage.getItem("alpha-agent-inputs-4");

    if (localStorageState === undefined || localStorageState === null || localStorageState === "") {
      let stateToSave = JSON.stringify(this.state);
      localStorage.setItem("alpha-agent-inputs-4", stateToSave);

    } else {
      localStorageState = JSON.parse(localStorageState);
      this.setState(localStorageState);
    }
  }

  componentDidUpdate() {
    console.log(this.state);
  }

  handleEdit = e => {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(prevState => {
      const newState = { ...prevState };
      newState[name] = value;
      return newState;
    }, () => {
      let stateToSave = JSON.stringify(this.state);
      localStorage.setItem("alpha-agent-inputs-4", stateToSave);
      console.log(this.state);
    });
  }

  handleAdd = async () => {
    await this.props.addCondition(this.state, 4);
    this.props.hideAddDialog();
  }

  render() {
    return (
      <div className={this.props.open ? "modal is-active" : "modal"}>
        <div className="modal-background" onClick={this.props.hideAddDialog}></div>

        <div className="modal-card is-fullwidth">
          <header className="modal-card-head">
            <h5 className="modal-card-title">Add Condition</h5>
            <button className="delete" onClick={this.props.hideAddDialog}></button>
          </header>

          <section className="modal-card-body">
            <p className="subtitle">Add a new condition which will run its seperate strategy instance</p>

            <form onSubmit={this.handleAdd}>
              <div className="field mb-3">
                <label htmlFor="broker-name" className="label">Broker Name:</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      id="broker-name"
                      name="brokerName"
                      onChange={this.handleEdit}
                      value={this.state.brokerName}
                    >
                      {
                        this.props.brokers.map(broker => (
                          <option value={broker.name}>{broker.name}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="datafeed-name" className="label">Datafeed Name:</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      id="datafeed-name"
                      name="datafeedName"
                      onChange={this.handleEdit}
                      value={this.state.datafeedName}
                    >
                      {
                        this.props.brokers.map(broker => (
                          <option value={broker.name}>{broker.name}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="scrip" className="label">Scrip:</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      id="scrip"
                      name="scrip"
                      value={this.state.scrip}
                      onChange={this.handleEdit}
                    >
                      <option value="NSE:NIFTY 50">NSE:NIFTY 50</option>
                      <option value="NSE:NIFTY BANK">NSE:NIFTY BANK</option>
                      <option value="NSE:NIFTY FIN SERVICE">NSE:NIFTY FIN SERVICE</option>
                      <option value="NSE:INDUSINDBK">NSE:INDUSINDBK</option>
                      <option value="NSE:KOTAKBANK">NSE:KOTAKBANK</option>
                      <option value="NSE:SBIN">NSE:SBIN</option>
                      <option value="NSE:AXISBANK">NSE:AXISBANK</option>
                      <option value="NSE:HDFCBANK">NSE:HDFCBANK</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="start-time" className="label">Start Time:</label>
                <div className="control">
                  <input
                    step="1"
                    type="time"
                    id="start-time"
                    name="startTime"
                    className="input"
                    onChange={this.handleEdit}
                    value={this.state.startTime}
                  />
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="strike-distance" className="label">Strike Distance:</label>
                <div className="control">
                  <input
                    type="number"
                    className="input"
                    id="strike-distance"
                    name="strikeDistance"
                    onChange={this.handleEdit}
                    value={this.state.strikeDistance}
                  />
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="prem-for-strike" className="label">Premium for Strike:</label>
                <div className="control">
                  <input
                    type="number"
                    className="input"
                    id="prem-for-strike"
                    name="premForStrike"
                    onChange={this.handleEdit}
                    value={this.state.premForStrike}
                  />
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="expiry" className="label">Expiry:</label>
                <div className="control">
                  <input
                    id="expiry"
                    type="date"
                    name="expiry"
                    className="input"
                    value={this.state.expiry}
                    onChange={this.handleEdit}
                  />
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="expiry-type" className="label">Expiry Type:</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      id="expiry-type"
                      name="expiryType"
                      onChange={this.handleEdit}
                      value={this.state.expiryType}
                    >
                      <option value="Weekly">Weekly</option>
                      <option value="Monthly">Monthly</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="lots" className="label">Lots:</label>
                <div className="control">
                  <input
                    id="lots"
                    name="lots"
                    type="number"
                    className="input"
                    value={this.state.lots}
                    onChange={this.handleEdit}
                  />
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="timeframe" className="label">Timeframe:</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      id="timeframe"
                      name="timeframe"
                      onChange={this.handleEdit}
                      value={this.state.timeframe}
                    >
                      <option value="minute">minute</option>
                      <option value="2minute">2minute</option>
                      <option value="3minute">3minute</option>
                      <option value="5minute">5minute</option>
                      <option value="10minute">10minute</option>
                      <option value="15minute">15minute</option>
                      <option value="30minute">30minute</option>
                      <option value="60minute">60minute</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="is-tpnl-enabled" className="label">Is Trail P&L Enabled:</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      id="is-tpnl-enabled"
                      name="isTpnlEnabled"
                      onChange={this.handleEdit}
                      value={this.state.isTpnlEnabled}
                    >
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="trading-mode" className="label">Trading Mode:</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      id="trading-mode"
                      name="tradingMode"
                      onChange={this.handleEdit}
                      value={this.state.tradingMode}
                    >
                      <option value="Paper">Paper</option>
                      <option value="Live">Live</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* <div className="field mb-3">
                <label htmlFor="entry-buffer-pct" className="label">Entry Buffer %:</label>
                <div className="control">
                  <input
                    type="number"
                    className="input"
                    id="entry-buffer-pct"
                    name="entryBufferPct"
                    onChange={this.handleEdit}
                    value={this.state.entryBufferPct}
                  />
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="sl-pct" className="label">SL %:</label>
                <div className="control">
                  <input
                    id="sl-pct"
                    name="slPct"
                    type="number"
                    className="input"
                    value={this.state.slPct}
                    onChange={this.handleEdit}
                  />
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="target" className="label">Target:</label>
                <div className="control">
                  <input
                    id="target"
                    name="target"
                    type="number"
                    className="input"
                    value={this.state.target}
                    onChange={this.handleEdit}
                  />
                </div>
              </div>

              <div className="field mb-3">
                <label htmlFor="pts-to-trail-at" className="label">Points to Trail At:</label>
                <div className="control">
                  <input
                    type="number"
                    className="input"
                    name="ptsToTrailAt"
                    id="pts-to-trail-at"
                    onChange={this.handleEdit}
                    value={this.state.ptsToTrailAt}
                  />
                </div>
              </div> */}
            </form>
          </section>

          <footer className="modal-card-foot">
            <button onClick={this.handleAdd} className="button is-primary">Add</button>
            <button onClick={this.props.hideAddDialog} className="button is-danger mx-2">Cancel</button>
          </footer>
        </div>
      </div>
    );
  }
}

export default Strategy4AddDialog;